import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../../components/Common/BreadCrumb/ReportBreadCrumb/ReportBreadCrumb";
import JobsHeader from "../../../../../components/Common/JobsHeader/JobsHeader";
import DownloadIcon from "../../../../../asset/jobs/download.svg";
import "./LOngoingReportJobs.scss";
import graphqlRequest from "../../../../../requestMethod";
import ReportOngoingJobTable from "../../../../../components/Table/Locum/ReportOngoingJobTable/ReportOngoingJobTable";
import Pdf from "react-to-pdf";
import FilterReportJobs from "../../../../../components/Common/FilterReportJobs/FilterReportJobs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { pushEvent } from "../../../../../utils/clevertap";
import dayjs from "dayjs";
const OngoingReportJobs = () => {
  let [downloadTable, setDownloadTable] = useState([]);
  let [loading, setLoading] = useState(false);
  let [tableData, setTableData] = useState([]);
  let [csvData, setCsvData] = useState([]);
  let [filterTable, setFilterTable] = useState([]);
  let [departmentList, setDepartmentList] = useState([]);
  let [departmentValue, setDepartmentValue] = useState("");
  let [professionalList, setProfessionalList] = useState([]);
  let [professionsValue, setProfessionValue] = useState("");
  let [globalInputSearch, SetGlobalInputSearch] = useState("");
  const [filterDate, setFilterDate] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [totalData, setTotalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  let [filterByProfession, setFilterByProfession] = useState("");
  let [filterByDepartment, setFilterByDepartment] = useState("");
  let [filterByStartDate, setFilterByStartDate] = useState("");
  let [filterByEndDate, setFilterByEndDate] = useState("");

  function check(start, end, current) {
    if (current >= start && current <= end) {
      return true;
    } else {
      return false;
    }
  }
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;

  function filterDepartment(data) {
    let onlyDep = Array?.from(
      new Set(data?.map((data) => data?.job?.department))
    );
    setDepartmentList(onlyDep);
  }
  function filterProfessional(data) {
    let onlyPro = Array.from(
      new Set(data?.map((data) => data?.professional?.professionalType?.name))
    );
    setProfessionalList(onlyPro);
  }
  let fetchOngoingReport = () => {
    setLoading(true);
    const query = `
    query {
      withAuth(token: "${token}") {
        listMiniJobApplications(type:ONGOING,limit: ${limit}, offset: ${currentPage},search: "${keyword}", filterByProfession: "${filterByProfession}", department: "${filterByDepartment}",startDate: "${filterByStartDate}", endDate:"${filterByEndDate}"){
        id
        status
        professional {
          id
          emails {
            isPrimary
            address
          }
          phoneNumbers {
            isPrimary
            number
          }
          name {
            full
          }
          address {
            state
            address
            country
            city
            country
            pin
          }
          specialization {
            name
            id
          }
          numExperience {
            id
            name
          }
          workCity {
            id
            name
          }
          qualification {
            id
            name
          }
          professionalType {
            id
            name
          }
          profile {
            dob
            gender
            pan
            aadhar
            social {
              facebook
              linkedin
            }
            covid
            jobHistory {
              hospital
              department
              specialisation
              start
              end
            }
            education {
              course
              specialisation
              name
              year
            }
            references {
              name
              hospital
              designation
              phone
              email
            }
          }
          languageKnownNew
          additionalTrainingNew
          workedOn {
            id
            softwarename
          }
          professionalRegistration {
            number
            registrationType {
              id
              name
            }
          }
          avatar {
            location
            fileName
            uri
            bucket
            region
            mimeType
            secureUrl
            url
            isSecured
            cdnUrl
          }
          correspondenceAddress {
            address
            city
            state
            pin
            country
          }
          departments {
            id
            name
          }
        }
        job {
            id
            code
            department
            specialization
            start
            end
            applications
            filled
          }
        }
      }
  }
    `;

    graphqlRequest(query).then((response) => {
      setTotalData(response?.data?.totalApplicationCount || 0);
      let data = response.data.withAuth.listMiniJobApplications;
      setLoading(false);
      let arr = [
        ["Job ID", "Specialization", "Profession Name", "Start Date & Time"],
      ];
      setTableData(data);
      filterDepartment(data);
      filterProfessional(data);
      setFilterTable(data);

      if (data) {
        data?.map((obj) => {
          let rowArray = [];
          rowArray.push(obj?.job?.code);
          rowArray.push(obj?.job?.specialization);
          rowArray.push(obj?.professional?.name?.full);

          rowArray.push(
            `${dayjs(Number(obj?.job?.start)).format("MMM D, YYYY, h:mm A")}`
          );

          arr.push(rowArray);
        });

        setCsvData(arr);
      }
    });
  };

  function filterCanceledJobTable(query) {
    let { department, professionalType, start, end } = query;
    function search(elem) {
      let flag = {};
      if (!!department) {
        flag.department = elem?.job?.department === department;
      }
      if (!!professionalType) {
        flag.professional =
          elem?.professional?.professionalType.name === professionalType;
      }
      if (!!start && !!end) {
        flag.time = check(start, end, new Date(Number(elem?.job?.start)));
      }
      return Object.values(flag).every((test) => test == true);
    }
    let filterData = tableData.filter(search);

    setFilterTable(filterData);
  }
  function filterGlobalSearch() {
    let data = tableData.filter((data) => {
      if (
        data.job.code.toUpperCase().includes(globalInputSearch.toUpperCase()) ||
        data.job.specialization
          .toUpperCase()
          .includes(globalInputSearch.toUpperCase()) ||
        data.professional?.name?.full
          .toUpperCase()
          .includes(globalInputSearch.toUpperCase())
      ) {
        return data;
      }
    });
    setFilterTable(data);
  }

  useEffect(() => {
    let query = {};
    !!departmentValue && (query["department"] = departmentValue);

    !!professionsValue && (query["professionalType"] = professionsValue);
    // create this like query and passed in funcation as an object
    !!filterDate[0]?.startDate &&
      (query["start"] = new Date(filterDate[0]?.startDate));
    !!filterDate[0]?.endDate &&
      (query["end"] = new Date(filterDate[0]?.endDate));

    query?.end && query?.end?.setHours(23, 59, 59);

    filterCanceledJobTable(query); // call that funcation, which filter the table data
  }, [departmentValue, professionsValue, filterDate]);

  useEffect(() => {
    filterGlobalSearch();
  }, [globalInputSearch]);

  useEffect(() => {
    fetchOngoingReport();
  }, [
    currentPage,
    limit,
    keyword,
    filterByProfession,
    filterByDepartment,
    filterByStartDate,
    filterByEndDate,
  ]);
  const ref = React.createRef();
  const options = {
    orientation: "landscape",
    unit: "in",
    format: [11, 10],
  };
  const handleCsvDownload = () => {
    const title = "Ongoing Job Report";
    pushEvent("Web_OngoingJobReport_CSV_Download", {
      page: "Reports",
      reportTitle: title,
    });
  };
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Ongoing Job Report";
    const headers = [
      ["Job ID", "Specialization", "Professional Name", "Start Date & Time"],
    ];
    pushEvent("Web_OngoingJobReport_Pdf_Download", {
      page: title,
    });
    const data = downloadTable?.map((elt) => [
      elt?.jobId,
      elt?.specialization,
      elt?.professionName,
      elt?.date,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Ongoing Jobs Report.pdf");
  };
  return (
    <div className="acceptedjob-container">
    <div className="acceptedjob-wrapper">
      <JobsHeader title={"Ongoing Jobs"} />
      <BreadCrumb action={"Jobs"} title={"Report"} title2={"Ongoing Jobs"} />
      <Pdf targetRef={ref} filename="OngoingJob.pdf" options={options}>
        {({ toPdf }) => (
          <FilterReportJobs
            fetchAllData={fetchOngoingReport}
            title={"Ongoing Jobs"}
            professional={"Ongoing Jobs"}
            dowload={"Download Pdf"}
            downloadIcon={DownloadIcon}
            toPdf={toPdf}
            csvData={csvData}
            departmentList={departmentList}
            professionalList={professionalList}
            SetGlobalInputSearch={SetGlobalInputSearch}
            setProfessionValue={setProfessionValue}
            setDepartmentValue={setDepartmentValue}
            globalInputSearch={globalInputSearch}
            setFilterTable={setFilterTable}
            setFilterDate={setFilterDate}
            filterDate={filterDate}
            tableData={tableData}
            professionsValue={professionsValue}
            departmentValue={departmentValue}
            exportPDF={exportPDF}
            handleCsvDownload={handleCsvDownload}
            keyword={keyword}
            setKeyword={setKeyword}
            filterByProfession={filterByProfession}
            setFilterByProfession={setFilterByProfession}
            filterByDepartment={filterByDepartment}
            setFilterByDepartment={setFilterByDepartment}
            filterByStartDate={filterByStartDate}
            setFilterByStartDate={setFilterByStartDate}
            filterByEndDate={filterByEndDate}
            setFilterByEndDate={setFilterByEndDate}
            downloadTable={downloadTable}
          />
        )}
      </Pdf>
      <div ref={ref} style={{ width: "100%" }}>
        <ReportOngoingJobTable
          tableData={tableData}
          filterTable={filterTable}
          loading={loading}
          setDownloadTable={setDownloadTable}
          totalData={totalData}
          currentPage={currentPage}
          limit={limit}
          setCurrentPage={setCurrentPage}
          setLimit={setLimit}
        />
      </div>
      </div>
    </div>
  );
};

export default OngoingReportJobs;
